<script>
import moment from 'moment';
import AddFacebookCampaignAction from './components/AddFacebookCampaignAction.vue';
import FacebookCampaignList from './components/FacebookCampaignList.vue';

export default {
  components: {
    FacebookCampaignList,
    AddFacebookCampaignAction,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      range: [],
    };
  },
  computed: {
    datePickerLabel() {
      if (this.range.length === 0) {
        return `${this.$t('global.beginOfTimeUntil')} ${moment().format('DD-MMM-YYYY')}`;
      }

      const [since, until] = this.range.map((date) => moment(date));

      if (since.isSame(until)) {
        return since.format('DD-MMM-YYYY');
      }

      return [
        this.$t('global.periodFrom'),
        since.format('DD-MMM-YYYY'),
        this.$t('global.periodΤο'),
        until.format('DD-MMM-YYYY'),
      ].join(' ');
    },
  },
  methods: {
    refresh() {
      this.$refs.facebookCampaignList.fetchFacebookCampaigns();
    },
  },
};
</script>

<template>
  <div class="space-y-8">
    <AddFacebookCampaignAction
      v-if="$isAdminOrSuperAdmin"
      :account-id="accountId"
      :project-id="projectId"
      @added="refresh"
    />
    <BaseCard class="overflow-hidden">
      <BaseCardHeader>
        <div class="flex">
          <div class="flex-1">
            <h3 class="text-xl font-medium text-gray-950">Facebook campaigns</h3>
          </div>
          <div class="max-w-lg">
            <BaseDatePicker v-model="range" :default-label="datePickerLabel">
              <template #default="{ shown }">
                <div
                  class="select-none rounded-md border border-gray-300 px-3 py-2 cursor-pointer"
                  :class="[shown ? '' : 'hover:bg-gray-100 hover:border-blue-600']"
                >
                  <div class="flex gap-3 items-center">
                    <div class="flex-1">
                      <span for="name" class="block text-xs font-medium text-gray-900 text-right">{{
                        $t('global.period')
                      }}</span>
                      <span
                        v-text="datePickerLabel"
                        class="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 sm:text-sm"
                      />
                    </div>
                    <div class="flex-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-4 h-4"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </template>
            </BaseDatePicker>
          </div>
        </div>
      </BaseCardHeader>
      <BaseCardBody clear-padding>
        <FacebookCampaignList
          ref="facebookCampaignList"
          :account-id="accountId"
          :project-id="projectId"
          :range="range"
        />
      </BaseCardBody>
    </BaseCard>
  </div>
</template>
